import { FC, useContext } from 'react';
import dynamic from 'next/dynamic';
import { Box } from '@chakra-ui/react';
import EntityContext from '../../../context/EntityContext';
import useActivityHotelMarkers from '../../../hooks/useActivityHotelMarkers';
import { ActivityFragmentFragment } from '../../../generated/types';

interface ActivityPoiMapProps {}

const HotelMap = dynamic(() => import('../../Common/HotelMap'), {
  ssr: false,
});

export const ActivityPoiMap: FC<ActivityPoiMapProps> = ({}) => {
  const entityContext = useContext(EntityContext);
  const mapMarkers = useActivityHotelMarkers(
    entityContext.entity as ActivityFragmentFragment,
    (entityContext.entity as any)?.category?.key
  );

  if (
    entityContext.entity.__typename !== 'Activity' &&
    entityContext.entity.__typename !== 'Hotel' &&
    entityContext.entity.__typename !== 'Poi'
  ) {
    return null;
  }

  const hasElevation =
    entityContext.entity.__typename === 'Activity' ||
    entityContext.entity.__typename === 'Poi';

  if (!entityContext.entity.location) {
    return null;
  }

  return (
    <Box className="ParagraphActivityPoiMap" my={8} width="100%">
      <HotelMap
        scrollWheelZoomDelayed
        scrollWheelZoom={false}
        data={entityContext.entity}
        markers={mapMarkers}
        center={entityContext.entity.location}
        elevationData={
          hasElevation ? (entityContext.entity as any).elevationData : undefined
        }
      />
    </Box>
  );
};

export default ActivityPoiMap;
